<template lang="pug">
#content.snap-content
  .overlay
  .header
    template(v-if="whiteLabel")
      router-link.back(to="/prematch")
        i.fas.fa-long-arrow-alt-left
        span {{ $t("ui.back") }}
      router-link.logo#v-step-0.ml-5(to="/tournament")
        img.w-100(src="/images/logo/wbet-tournament-logo.png")
    template(v-else)
      //- router-link.logo#v-step-0(to="/tournament")
      //-   img.w-100(v-if="cnyMode" :src="logoCNYPath")
      //-   img.w-100(v-else :src="logoPath")
      .flex-fill.tournament-header-right
        router-link.logo#v-step-0(to="/tournament")
          img.w-100(src="/images/logo/wbet-tournament-logo.png")
        //- | {{ $t("ui.tournament") }}
        //- i.fas.fa-plus
    .userpart
      .username
        span.user-id {{ displayName }}
        span.points {{ currencyCode }}
  .content-center
    //- small {{ roomList }}
    .content-center-body
      template(v-if="room.mode === 0")
        .category-group
          .scrolling-wrapper
            .category(:class="{'active': roomType===0}" @click="roomType = 0")
              i.fad.mr-1(:class="roomType===0?'fa-door-open':'fa-door-closed'")
              span {{ $t('m.ROOM_T0') }}
              span.ml-1(v-if="roomStats.hasOwnProperty(0)") ({{ roomStats[0].room_active }}/{{ roomStats[0].room_total }})
            .category#v-step-1(:class="{'active': roomType===1}" @click="roomType=1")
              i.fad.mr-1(:class="roomType===1?'fa-door-open':'fa-door-closed'")
              span {{ $t('m.ROOM_T1') }}
              span.ml-1(v-if="roomStats.hasOwnProperty(1)") ({{ roomStats[1].room_active }}/{{ roomStats[1].room_total }})
            .category#v-step-2(:class="{'active': roomType===2}" @click="roomType=2")
              i.fad.mr-1(:class="roomType===2?'fa-door-open':'fa-door-closed'")
              span {{ $t('m.ROOM_T2') }}
              span.ml-1(v-if="roomStats.hasOwnProperty(2)") ({{ roomStats[2].room_active }}/{{ roomStats[2].room_total }})
            .category#v-step-3(:class="{'active': roomType===3}" @click="roomType=3")
              i.fad.mr-1(:class="roomType===3?'fa-door-open':'fa-door-closed'")
              span {{ $t('m.ROOM_T3') }}
              span.ml-1(v-if="roomStats.hasOwnProperty(3)") ({{ roomStats[3].room_active }}/{{ roomStats[3].room_total }})
        .toolbar
          .search-btn-wrapper
            .d-flex.align-items-center
              .dropdown
                a.dropdown-btn(href="javascript:void(0)" data-toggle='dropdown') {{ roomFilter==0 ? $t('m.ROOM_A') : $t('m.ROOM_' + roomFilter) }}
                ul.dropdown-menu(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false' v-model="roomFilter" :disabled="loading.getRoomList")
                  li.dropdown-item(:class="{'bg-warning': roomFilter==0}" @click="setRoomFilter('0')")
                    a(href="javascript:void(0)") {{ $t('m.ROOM_A') }}
                  li.dropdown-item(:class="{'bg-warning': roomFilter==1}" @click="setRoomFilter('1')")
                    a(href="javascript:void(0)") {{ $t('m.ROOM_1') }}
                  li.dropdown-item(:class="{'bg-warning': roomFilter==2}" @click="setRoomFilter('2')")
                    a(href="javascript:void(0)") {{ $t('m.ROOM_2') }}
                  li.dropdown-item(:class="{'bg-warning': roomFilter==3}" @click="setRoomFilter('3')")
                    a(href="javascript:void(0)") {{ $t('m.ROOM_3') }}
                  li.dropdown-item(:class="{'bg-warning': roomFilter==4}" @click="setRoomFilter('4')")                  
                    a(href="javascript:void(0)") {{ $t('m.ROOM_4') }}
                  li.dropdown-item(:class="{'bg-warning': roomFilter==10}" @click="setRoomFilter('10')")
                    a(href="javascript:void(0)") {{ $t('m.ROOM_10') }}
              .form-check
                label.checkbox-label
                  span {{ $t('ui.joined') }}
                  input(v-model="joined_only" type='checkbox' checked='checked')
                  span.checkmark
            .flex-fill.icon-wrap
              a(href='javascript:void(0);' @click="roomRules()")
                i.fas.fa-info
              a.bg-info(href='javascript:void(0);' @click="replayTour()")
                i.fas.fa-globe-asia
              a(href='javascript:void(0);' @click="replayIntro()")
                i.fab.fa-youtube-square.fa-xl
            .input-group
              input.form-control(type="text", :placeholder="$t('ui.room_id')" v-model="searchId" :disabled="loading.getRoomList")
              button.search-btn(type="button" @click="getRoomList" :disabled="loading.getRoomList")
        .pagination-wrapper
          v-pagination(
            :value="page.value"
            :page-count="page.count"
            :classes="bootstrapPaginationClasses"
            :labels="paginationAnchorTexts"
            @input="changePage($event)"
          )
        template(v-if="loading.getRoomList")
          .loader-wrapper
            .loader.pf
        template(v-else)
          template(v-if="roomList.length > 0")
            template(v-for="room in roomList")
              roomList(:room="room" @room-enter="enterRoom")
          template(v-else)
            .note-panel.text-center {{ $t('message.no_room') }}
      template(v-if="room.mode === 1")
        roomJoin(:roomData="room.data" @room-leave="leaveRoom")
      template(v-if="room.mode === 2")
        roomGame(:roomId="room.id" @room-leave="leaveRoom")
  template(v-if="room.mode === 2")
    template(v-if="room.data.room_join === 1 && [0,1].includes(room.data.room_status)")
      roomBetSlip2(:roomId="room.id" @room-leave="leaveRoom")
  template(v-if="room.mode === 0")
    ul.nav.nav-pills.tournament-pills.create-room
      li.nav-item.flex-fill
        router-link(to="/roomCreate")
          .nav-link.tnm-betslip
            i.fa.fa-plus.mr-2
            | {{ $t('ui.create_room') }}
  template(v-if="room.mode === 2")
    ul.nav.nav-pills.tournament-pills
      template(v-if="room.data.room_join != 1")
        li.nav-item(v-if="room.data && room.data.room_count < room.data.room_limit" @click="joinRoom" :class="{'d-none': room.data.room_status != 0}")
          .nav-link.tnm-betslip
            i.far.fa-sign-in.mr-2
            | {{ $t('ui.join_now') }}
      li.nav-item.flex-fill(@click="leaveBetRoom")
        .nav-link.tnm-mybet
          i.fas.fa-door-open.mr-2
          | {{ $t('ui.leave_room') }}
  v-tour(name="tour1" :steps="steps" :callbacks="callbacks" :options="options")
</template>

<script>
import Vue from "vue";
import config from "@/config";
import errors from "@/errors";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/views/tournament/library/_xhr.js";
import vPagination from "vue-plain-pagination";

export default {
  components: {
    vPagination,
    roomList: () => import("@/views/tournament/components/roomList.vue"),
    roomJoin: () => import("@/views/tournament/components/roomJoin.vue"),
    roomGame: () => import("@/views/tournament/components/roomGame.vue"),
    roomBetSlip2: () => import("@/views/tournament/components/roomBetSlip2.vue")
  },
  data() {
    return {
      searchId: "",
      joined_only: false,
      room: {
        id: null,
        data: null,
        mode: 0
      },
      roomType: 0,
      roomFilter: "0",
      privateRoom: false,
      page: {
        value: 1,
        count: 1,
        total: 0
      },
      bootstrapPaginationClasses: {
        ul: "pagination justify-content-center",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
        buttonActive: "active",
        buttonDisable: "disable"
      },
      paginationAnchorTexts: {
        first: "&laquo;",
        prev: "&lsaquo;",
        next: "&rsaquo;",
        last: "&raquo;"
      },
      roomList: [],
      roomStats: {},
      loading: {
        getRoomList: false
      },
      result: false,
      options: {
        labels: {
          buttonSkip: this.$t("message.button_skip"),
          buttonPrevious: this.$t("message.button_previous"),
          buttonNext: this.$t("message.button_next"),
          buttonStop: this.$t("message.button_continue")
        }
      },
      callbacks: {
        onStart: this.onStart,
        onPreviousStep: this.onPreviousStep,
        onNextStep: this.onNextStep,
        onSkip: this.onSkip,
        onFinish: this.onFinish,
        onStop: this.onStop,
      },
      steps: [
        {
          target: '#v-step-0',
          content: this.$t("message.tour_content_1")
        },
        {
          target: '#v-step-1',
          content: this.$t("message.tour_content_2")
        },
        {
          target: '#v-step-2',
          content: this.$t("message.tour_content_3")
        },
        {
          target: '#v-step-3',
          content: this.$t("message.tour_content_4")
        },
        {
          target: '.status',
          content: this.$t("message.tour_content_8")
        },
        {
          target: '.tournament-pills.create-room',
          content: this.$t("message.tour_content_9")
        },
        {
          target: '.join-now-wrapper',
          content: this.$t("message.tour_content_5")
        },
      ]
    };
  },
  computed: {
    tour1() {
      return this.$store.state.layout.tour1;
    },
    logoPath() {
      return config.logoPath;
    },
    cnyMode() {
      return config.cnyMode;
    },
    logoCNYPath() {
      return config.logoCNYPath;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace('UST', 'USDT');
    },
    nickname() {
      return this.$store.getters.nickName;
    },
    account_id() {
      return this.$store.getters.accountId;
    },
    displayName() {
      if (this.nickname) return this.nickname;
      else return this.account_id;
    },
    language() {
      return this.$store.getters.language;
    },
    pageSize() {
      return 10;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    }
  },
  watch: {
    roomFilter() {
      this.resetList();
      this.getRoomList();
    },
    roomType() {
      this.resetList();
      this.getRoomList();
    },
    joined_only() {
      this.resetList();
      this.getRoomList();
    }
  },
  destroyed() {
    EventBus.$off("roomEnterById");
    EventBus.$off("room-leave");
  },
  mounted() {
    this.getRoomList();
    EventBus.$on("room-leave", this.leaveRoom());
    EventBus.$on("roomEnterById", e => {
      this.getRoomListById(e);
    });

    if (this.$route.query.triggerFunction) {
      var id = this.$route.query.roomID
      this.getRoomListById(id);
    }

    if (this.tour1 == false) this.$tours['tour1'].start();
  },
  methods: {
    onStart() {
    },
    onPreviousStep(currentStep) {
      // console.log("onPreviousStep", currentStep);
    },
    onNextStep(currentStep) {
      // console.log("onNextStep", currentStep);
    },
    onSkip() {
      this.$store.dispatch("layout/setTour1", true);
    },
    onFinish() {
      $(".join-now-wrapper")[0].click();
    },
    onStop() {
      // this.$store.dispatch("layout/setTour1", true);
    },
    replayTour() {
      this.$store.dispatch("layout/setTour1", false);
      this.$tours['tour1'].start();
    },
    replayIntro() {
      $("#modal-tournament-ads").modal("show");
    },
    roomRules() {
      $("#room-rules").modal("show");
    },
    setRoomFilter(e) {
      this.roomFilter = e;
    },
    isResultMode(e) {
      return this.result = e
    },
    showMe(){
      $('.content-center-body').addClass('d-none');
      $('.tournament-betslip-wrapper .tab-content').removeClass('d-none').addClass('d-flex');
      $('.tournament-betslip-wrapper .tab-content #pills-betslip').addClass('show').addClass('active');
    },
    closeMe() {
      $('.content-center-body').removeClass('d-none');
      $('.content-center .tnm-betslip').removeClass('active');
      $('.tournament-betslip-wrapper .tab-content').removeClass('d-flex').addClass('d-none');
      $('.tournament-betslip-wrapper .tab-content #pills-betslip').removeClass('show').removeClass('active');
    },
    resetList() {
      this.page.value = 1;
      this.page.count = 1;
      this.page.total = 0;
    },
    leaveBetRoom(){
      this.closeMe();
      this.room.id = null;
      this.room.data = null;
      this.room.mode = 0;
      this.getRoomList();
    },
    leaveRoom() {
      this.room.id = null;
      this.room.data = null;
      this.room.mode = 0;
      this.getRoomList();
    },
    enterRoom(room) {
      this.room.id = room.room_id;
      this.room.data = room;
      this.room.mode = 2;
    },
    joinRoom(room) {
      // this.room.id = room.room_id;
      // this.room.data = room;
      this.room.mode = 1;
    },
    getRoomList() {
      // if searchId is not empty, then must be integer and greater than 0
      var room_id = 0;
      if (this.searchId != "") {
        if (!isNaN(this.searchId) && this.searchId > 0) {
          // convert searchId to integer and assing to room_id
          room_id = parseInt(this.searchId);
        }
      }

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_status: parseInt(this.roomFilter),
        room_type: parseInt(this.roomType),
        room_id: room_id,
        joined_only: this.joined_only === true ? 1 : 0,
        pay_type: 2,
        page_number: this.page.value,
        page_size: this.pageSize,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession
      };

      this.loading.getRoomList = true;
      service.getRoomList(config.tournamentUrl().roomlist, json).then(
        result => {
          this.loading.getRoomList = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              var rn = result.data.extra;
              // loop through rn and assign to this.roomStats by room_type as key and item as value
              // check if this.roomStats[room_type] has not own property, then assign empty object
              // then assign item to this.roomStats[room_type]
              var allRoom = {
                room_type: 0,
                room_active: 0,
                room_count: 0,
                room_total: 0
              };
              for (var i = 0; i < rn.length; i++) {
                var item = rn[i];

                allRoom.room_active += item.room_active;
                allRoom.room_count += item.room_count;
                allRoom.room_total += item.room_total;
                if (!this.roomStats.hasOwnProperty(item.room_type)) {
                  this.roomStats[item.room_type] = {};
                }
                this.roomStats[item.room_type] = item;
              }
              this.roomStats[0] = allRoom;

              // check if this.roomStats has own property 2, if yes, check if room_count if equal or greater than room_total, if yes then set this.privateRoom to true
              if (this.roomStats.hasOwnProperty(2)) {
                if (this.roomStats[2].room_active >= this.roomStats[2].room_total) {
                  this.privateRoom = false;
                } else {
                  this.privateRoom = true;
                }
              } else {
                this.privateRoom = true;
              }

              this.roomList = [];
              this.roomList = result.data.value;
              if (this.roomList.length > 0) {
                this.page.total = this.roomList[0].totalrows;
                if (this.page.total % this.pageSize != 0) {
                  this.page.count = Math.ceil(parseFloat(this.page.total) / parseFloat(this.pageSize));
                } else {
                  this.page.count = parseFloat(this.page.total) / parseFloat(this.pageSize);
                }
              } else {
                this.resetList();
              }

              if (this.room.id != null) {
                var m = false;
                for (var n = 0; n < this.roomList.length; n++) {
                  if (this.room.id === this.roomList[n].room_id) {
                    m = true;
                    break;
                  }
                }
                if (m === false) {
                  this.room.id = null;
                  this.room.data = null;
                  this.room.mode = 0;
                }
              }
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        err => {
          console.log(err);
          this.loading.getRoomList = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getRoomListById(e) {
      var room_id = e;
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_status: 10,
        room_type: 0,
        room_id: room_id,
        joined_only: 0,
        pay_type: 2,
        page_number: 1,
        page_size: 1,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession
      };

      service.getRoomList(config.tournamentUrl().roomlist, json).then(
        result => {
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              var rn = result.data.extra;
              // loop through rn and assign to this.roomStats by room_type as key and item as value
              // check if this.roomStats[room_type] has not own property, then assign empty object
              // then assign item to this.roomStats[room_type]
              var allRoom = {
                room_type: 0,
                room_active: 0,
                room_count: 0,
                room_total: 0
              };
              for (var i = 0; i < rn.length; i++) {
                var item = rn[i];
                allRoom.room_active += item.room_active;
                allRoom.room_count += item.room_count;
                allRoom.room_total += item.room_total;
                if (!this.roomStats.hasOwnProperty(item.room_type)) {
                  this.roomStats[item.room_type] = {};
                }
                this.roomStats[item.room_type] = item;
              }
              this.roomStats[0] = allRoom;

              // check if this.roomStats has own property 2, if yes, check if room_count if equal or greater than room_total, if yes then set this.privateRoom to true
              if (this.roomStats.hasOwnProperty(2)) {
                if (this.roomStats[2].room_active + this.roomStats[2].room_count >= this.roomStats[2].room_total) {
                  this.privateRoom = false;
                } else {
                  this.privateRoom = true;
                }
              } else {
                this.privateRoom = true;
              }

              var room = result.data.value[0];
              if (room != null) {
                // if room_id is not found, then push to this.roomList
                // if room_id is found, then update this.roomList
                var m = false;
                for (var n = 0; n < this.roomList.length; n++) {
                  if (room_id === this.roomList[n].room_id) {
                    Vue.set(this.roomList, n, result.data.value[0]);
                    m = true;
                    break;
                  }
                }

                if (m === false) {
                  this.roomList.push(result.data.value[0]);
                }

                this.room.id = room.room_id;
                this.room.data = room;
                this.room.mode = 2;
              }
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        err => {
          console.log(err);
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    changePage(e) {
      this.page.value = e;
      this.getRoomList();
    }
  }
}
</script>